import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

/**
 * Payroll Analytics — Owner
 * GET /api/payroll-runs/analytics?year=&month=
 */
export const getPayrollAnalytics = async (params = {}) => {
  const res = await axiosInstance.get("/api/payroll-runs/analytics", { params });
  return res.data;
};

/**
 * Payroll Analytics — Portal
 * GET /api/payroll-portal/analytics?year=&month=
 */
export const getPayrollAnalyticsPortal = async (params = {}) => {
  const res = await axiosInstance.get("/api/payroll-portal/analytics", { params });
  return res.data;
};
